module.exports = __webpack_public_path__ + "static/deciding-choosing-37903a3156e08f49a69661df9560cef7.jpg";